import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState,useEffect } from "react";
import editapi from '../api/completionListRouter';
import loginapi from '../api/login';

import { APISERVERURL } from '../APIServerURL';


const MeritTable = ({ students, busy,downloadFile,fn }) => {
  if (busy) {
    return (
      <div className="text-center py-4 text-blue-500 font-semibold">
        Please wait. It might take upto a few minutes..
      </div>
    );
  }

  if (!students || students.length === 0) {
    return (
      <div className="text-center py-4 text-gray-600">
        No data found.
      </div>
    );
  }

  return (
    <div className="overflow-x-auto w-full max-w-7xl mx-auto">
      <div className="w-full flex justify-end p-3">
        <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 hover:bg-green-600 hover:scale-105 active:scale-95"
              onClick={() => downloadFile(fn)}>
                download
              </button>
      </div>
      <table className="min-w-full border border-gray-300 text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="border px-2 py-1">Sl. No</th>
            <th className="border px-2 py-1">Roll No</th>
            <th className="border px-2 py-1">Name</th>
             <th className="border px-2 py-1">EntrySession</th>
               <th className="border px-2 py-1">MaxNoOfSem</th>
              <th className="border px-2 py-1">ValidUpTo</th>
            <th className="border px-2 py-1">LastAppeard</th>
            <th className="border px-2 py-1">Total Credit</th>
              <th className="border px-2 py-1">Credit Required</th>
            <th className="border px-2 py-1">Earned Credit</th>
           
              <th className="border px-2 py-1">CompletionStatus</th>
            <th className="border px-2 py-1">Total HonourPoint</th>
            <th className="border px-2 py-1">Core CGPA</th>
            <th className="border px-2 py-1">All CGPA</th>
          </tr>
        </thead>
        <tbody>
          {students.map((s, index) => (
            <tr key={s.rollno}>
              <td className="border px-2 py-1 text-center">{index + 1}</td>
              <td className="border px-2 py-1">{s.rollno}</td>
              <td className="border px-2 py-1">{s.name}</td>
              <td className="border px-2 py-1">{s.entrySession}</td>
              <td className="border px-2 py-1">{s.maxNoOfSemesters}</td>
              <td className="border px-2 py-1">{s.upToSession}</td>
              <td className="border px-2 py-1">{s.result.result.lastSession}</td>
              <td className="border px-2 py-1 text-right">{s.result.result.totalAllCredit ?? "-"}</td>
                   <td className="border px-2 py-1 text-right">{s.creditRequired ?? "-"}</td>
              <td className="border px-2 py-1 text-right">{s.result.result.totalCreditEarned ?? "-"}</td>
         

<td className="border px-2 py-1 text-right">
  {s.completionStatus}
</td>



              <td className="border px-2 py-1 text-right">{s.result.result.totalAllGp?.toFixed(2) ?? "-"}</td>
              <td className="border px-2 py-1 text-right">{s.result.result.majorCgpa?.toFixed(2) ?? "-"}</td>
              <td className="border px-2 py-1 text-right">{s.result.result.allCgpa?.toFixed(2) ?? "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
      
    </div>
  );
};





function MeritList({accessToken,setAccessToken,setRefreshFailed,sessions  }) {
  const levels = ["UG-20","UG-21", "UG-22", "PG-20", "PG-21", "PG-22", "PG-23","MTT-25"];
  const navigate = useNavigate();
  const [session,setSession]=useState('');  
  const [error,setError]=useState('');
  const [level, setLevel] = useState("");
const [busy,setBusy]=useState(false);
const [fileName,setFileName]=useState('');

  const[students,setStudents]=useState([]);

  const handleGoBack = () => {
    navigate(`/`); 
  };

const sessionChanged = async (e) => {
    const session = e.target.value;
    setSession(session);

  };



const levelChanged = (e) => {
  setLevel(e.target.value);
};

  function downloadFile(fname)
    {
      fetch(`${APISERVERURL}/pdf/${fname}`).then((response) => {
        response.blob().then((blob) => {
         
            // Creating new object of PDF file
            const fileURL =
                window.URL.createObjectURL(blob);
                 
            // Setting various property values
            let alink = document.createElement("a");
            alink.href = fileURL;
            alink.download = fname;
            alink.click();
            //setIsloading(false);
        });
      });
    }

    
    async function handleSearch()
        {
          setStudents([]);
          setFileName('');
          setBusy(true);
          try{
            const response= await editapi.post('/getCompletionList',{ level,session},{headers:{'Authorization':`Bearer ${accessToken}`}});    
             // alert(response.data);
        //downloadFile(response.data); 
              setStudents(response.data.result);
              setFileName(response.data.filename);
          }
          catch(err)
          {
            if( err.response.status===403)
              {
                navigate(`/accessdenied`); 
              }
            try{
              const config = { withCredentials: true };
              const x=await loginapi.get('/getAccessToken',config);
              
              const nat=x['data']['accessToken'];
              setAccessToken(nat);
              try{       
                const response= await editapi.post('/getCompletionList',{ level,session},{headers:{'Authorization':`Bearer ${nat}`}});    
                      //alert(response.data);
        //downloadFile(response.data);
        setStudents(response.data.result);
        setFileName(response.data.filename);
               }
               catch(err)
               {
                if( err.response.status===403)
                  {
                    navigate(`/accessdenied`); 
                  }
                alert('unusual error newposts.js');
               }
            }
            catch(err)
            {
              alert('failed');
            }
    
          }
          finally
          {
            setBusy(false);
          }
        }
  
           
 


  return (
     <main className="w-full">
         <div className="flex flex-col items-center w-full">


         <div className="w-full bg-red-100 relative py-1">
            {/* Absolute Positioned Button */}
            <button  onClick={handleGoBack}  className="absolute top-1.5 left-1.5 bg-red-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-red-600 transition duration-300 text-xs">
              BACK
            </button>

            {/* Heading */}
            <h1 className="text-2xl  text-gray-400 text-center"> COMPLETION  LIST</h1>
            <p className="w-full text-center font-semibold text-xs text-transparent">(The form is autosave)</p>    
          </div>

    

      <div className="flex flex-col justify-center gap-4 mt-4">
       
        
        

        <div className="w-full flex flex-col items-center justify-center mt-4 ">
               

               <div
                  className="flex flex-col items-center justify-center  w-full max-w-[600px] p-1 text-sm mb-2 "
                >
                <p className="text-center">Select Current session</p>
            <select
        value={session}
        onChange={(e) => sessionChanged(e)}
        className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
      >
        <option value="">-- Choose a session --</option>
        {sessions.map((session, index) => (
          <option key={index} value={session}>
            {session}
          </option>
        ))}
      </select>
               </div>

               <div className="flex flex-col items-center justify-center w-full max-w-[600px] p-1 text-sm mb-2">
    <p className="text-center">Select Batch</p>
    <select
      value={level}
      onChange={levelChanged}
      className="w-full p-2 mt-1 bg-transparent border-b border-gray-400 focus:border-green-500 focus:border-b outline-none transition-all"
    >
      <option value="">-- Choose a level --</option>
      {levels.map((levelItem, index) => (
        <option key={index} value={levelItem}>
          {levelItem}
        </option>
      ))}
    </select>
  </div>


              <button
  className={`bg-green-500 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300 
    ${busy ? 'opacity-50 cursor-not-allowed' : 'hover:bg-green-600 hover:scale-105 active:scale-95'}`}
  onClick={handleSearch}
  disabled={busy}
>
  {busy ? "Please wait..." : "GET COMPLETION LIST"}
</button>

<div className="mt-4">
 <MeritTable students={students} busy={busy} downloadFile={downloadFile} fn={fileName} />
</div>

        </div>

       


      </div>
      </div>
    </main>
  );
}

export default MeritList;
